import React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';

const ReportActionConfirmModal = ({ open, onClose, onConfirm, actionTarget }) => {
  const roleLabel = actionTarget?.role === 'instructor' ? 'Instructor' : 'Learner';
  const name = actionTarget?.user?.name || '';

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="report-action-confirm-title">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 420,
          maxWidth: '90vw',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: '12px',
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography
          id="report-action-confirm-title"
          sx={{
            fontFamily: 'Poppins',
            fontSize: '16px',
            fontWeight: 600,
            color: '#14171F',
            mb: 1,
          }}
        >
          Confirm account review
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Poppins',
            fontSize: '13px',
            color: '#4B5563',
          }}
        >
          You are about to review and potentially restrict the account of{' '}
          <strong>
            {roleLabel} {name}
          </strong>
          . Make sure you have checked the session details, recordings and chat history before
          proceeding.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.5,
            mt: 1,
          }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              textTransform: 'none',
              fontFamily: 'Poppins',
              fontSize: '13px',
              borderRadius: '999px',
              px: 2.5,
              py: 0.75,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            sx={{
              textTransform: 'none',
              fontFamily: 'Poppins',
              fontSize: '13px',
              borderRadius: '999px',
              px: 2.5,
              py: 0.75,
              backgroundColor: '#E14949',
              '&:hover': {
                backgroundColor: '#C73636',
              },
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ReportActionConfirmModal;
